/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BillingLimits } from "./BillingLimits";
export const BillingLimitsResponse = core.serialization.object({
    data: BillingLimits,
});
